module.exports = __webpack_public_path__ + "img/f66be9a.jpg";